var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["col-" + _vm.colSize] }, [
    _c("div", { staticClass: "form-page" }, [
      _vm.prompt
        ? _c("p", { staticClass: "text-justify" }, [
            _vm._v("\n      " + _vm._s(_vm.prompt) + "\n    "),
          ])
        : _vm.promptHTML
        ? _c("p", {
            staticClass: "text-justify",
            domProps: { innerHTML: _vm._s(_vm.promptHTML) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("article", { staticClass: "d-flex mb-0" }, [
        _c(
          "div",
          { staticClass: "form-container fe-radio-form large-radio px-0" },
          [
            _c("div", { staticClass: "fe-option" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.option,
                    expression: "option",
                  },
                ],
                attrs: { id: "no-" + _vm.id, type: "radio", value: "0" },
                domProps: { checked: _vm._q(_vm.option, "0") },
                on: {
                  change: [
                    function ($event) {
                      _vm.option = "0"
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("label", { attrs: { for: "no-" + _vm.id } }, [
                _vm._v(_vm._s(_vm.$t("global.words.no"))),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-container fe-radio-form large-radio px-0" },
          [
            _c("div", { staticClass: "fe-option" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.option,
                    expression: "option",
                  },
                ],
                attrs: { id: "yes-" + _vm.id, type: "radio", value: "1" },
                domProps: { checked: _vm._q(_vm.option, "1") },
                on: {
                  change: [
                    function ($event) {
                      _vm.option = "1"
                    },
                    _vm.handleChange,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "checkmark" }),
              _vm._v(" "),
              _c("label", { attrs: { for: "yes-" + _vm.id } }, [
                _vm._v(_vm._s(_vm.$t("global.words.yes"))),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.extraOptions
          ? _c(
              "div",
              _vm._l(_vm.extraOptions, function (extraOption) {
                return _c(
                  "div",
                  {
                    key: extraOption.id,
                    staticClass:
                      "form-container fe-radio-form large-radio px-0",
                  },
                  [
                    _c("div", { staticClass: "fe-option" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.option,
                            expression: "option",
                          },
                        ],
                        attrs: {
                          id: extraOption.id,
                          type: "radio",
                          value: "2",
                        },
                        domProps: { checked: _vm._q(_vm.option, "2") },
                        on: {
                          change: [
                            function ($event) {
                              _vm.option = "2"
                            },
                            _vm.handleChange,
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkmark" }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: extraOption.id } }, [
                        _vm._v(_vm._s(extraOption.text)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-column" }, [
      _c("label", { attrs: { for: "textarea-" + _vm.id } }, [
        _c("strong", { staticClass: "my-1" }, [
          _vm._v(_vm._s(_vm.computedExplainLabel)),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text",
          },
        ],
        staticClass: "yes-no-expalin",
        attrs: {
          id: "textarea-" + _vm.id,
          cols: "4",
          rows: "3",
          maxlength: _vm.maxlength,
          disabled: _vm.shouldDisableInput,
        },
        domProps: { value: _vm.text },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.text = $event.target.value
            },
            _vm.handleChange,
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }